var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('small',{attrs:{"color":"blue"}},[_vm._v(" "+_vm._s(this.fvalue))]),_c('v-autocomplete',{attrs:{"items":_vm.options,"label":this.title},on:{"change":function($event){return _vm.onClickButton()}},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }